import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import { fetchCurrentUser } from '../../ducks/user.duck';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import {
  TRANSITION_WORKER_CANCEL_BEFORE_START_1,
  TRANSITION_WORKER_CANCEL_BEFORE_START_24,
} from '../../util/transaction';
const { UUID } = sdkTypes;
// ================ Action types ================ //
export const FETCH_LISTING_TRANSACTION_REQUEST =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_REQUEST';
export const FETCH_LISTING_TRANSACTION_SUCCESS =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_SUCCESS';
export const FETCH_LISTING_TRANSACTION_ERROR =
  'app/BusinessDashboard/FETCH_LISTING_TRANSACTION_ERROR';
export const FETCH_LISTINGS_SUCCESS = 'app/BusinessDashboard/FETCH_LISTINGS_SUCCESS';
export const FETCH_LISTINGS_REQUEST = 'app/BusinessDashboard/FETCH_LISTINGS_REQUEST';
export const FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST';
export const FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS';
export const FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR =
  'app/BusinessDashboard/FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR';
export const FETCH_ASSIGNED_WORKER_REQUEST = 'app/BusinessDashboard/FETCH_ASSIGNED_WORKER_REQUEST';
export const FETCH_ASSIGNED_WORKER_SUCCESS = 'app/BusinessDashboard/FETCH_ASSIGNED_WORKER_SUCCESS';
export const FETCH_ASSIGNED_WORKER_ERROR = 'app/BusinessDashboard/FETCH_ASSIGNED_WORKER_ERROR';
// ================ Reducer ================ //
const initialState = {
  fetchListingReq: false,
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentPageWorkers: [],
  unverifiedWorkers: [],
  listingTransactions: {},
  fetchAppliedListInProgress: false,
  fetchAppliedlistSuccess: false,
  fetchAppliedlistError: null,
  workingStaffs: [],
  workingStaffsRequest: false,
  workingStaffsError: null,
  listingId: [],
  listing: [],
  assignedWorker: [],
};
export default function ApplicantShowingPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LISTING_TRANSACTION_REQUEST:
      return {
        ...state,
        assignedWorker: [],
        fetchInProgress: true,
      };
    case FETCH_LISTING_TRANSACTION_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        listingTransactions: {
          ...state.listingTransactions,
          [payload.listingId]: payload.data,
        },
        // listingId: payload.formattedListingId,
      };
    }
    case FETCH_LISTING_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        fetchInProgress: false,
        ...state,
      };
    case FETCH_LISTINGS_SUCCESS: {
      return {
        ...state,
        fetchListingReq: false,
        listing: payload,
      };
    }
    case FETCH_LISTINGS_REQUEST: {
      return {
        ...state,
        fetchListingReq: true,
      };
    }
    case FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        listingTransactions: {},
      };
    case FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentPageWorkers: payload.data,
        pagination: payload.meta,
      };
    }
    case FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
      };
    case FETCH_ASSIGNED_WORKER_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        assignedWorker: [],
      };
    case FETCH_ASSIGNED_WORKER_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        assignedWorker: payload,
        // pagination: payload.meta,
      };
    }
    case FETCH_ASSIGNED_WORKER_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        fetchInProgress: false,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchListingTransactionsRequest = () => ({ type: FETCH_LISTING_TRANSACTION_REQUEST });
const fetchListingRequest = () => ({ type: FETCH_LISTINGS_REQUEST });
const fetchListingTransactionsSuccess = response => ({
  type: FETCH_LISTING_TRANSACTION_SUCCESS,
  payload: response,
});
const fetchListingTransactionsError = e => ({
  type: FETCH_LISTING_TRANSACTION_ERROR,
  error: true,
  payload: e,
});
const fetchListingSuccess = res => ({
  type: FETCH_LISTINGS_SUCCESS,
  payload: res,
});
const fetchListingAwaitingAcceptanceRequest = () => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_REQUEST,
});
const fetchListingAwaitingAcceptanceSuccess = response => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_SUCCESS,
  payload: response,
});
const fetchListingAwaitingAcceptanceError = e => ({
  type: FETCH_LISTING_AWAITING_ACCEPTANCE_ERROR,
  error: true,
  payload: e,
});
const fetchAssignedWorkerRequest = response => ({
  type: FETCH_ASSIGNED_WORKER_REQUEST,
});
const fetchAssignedWorkerSuccess = response => ({
  type: FETCH_ASSIGNED_WORKER_SUCCESS,
  payload: response,
});
const fetchAssignedWorkerError = e => ({
  type: FETCH_ASSIGNED_WORKER_ERROR,
  error: true,
  payload: e,
});
export const fetchListingTransactions = (formattedListingId, perPage = 4, page = 1) => (
  dispatch,
  getState,
  sdk
) => {
  let apiResp;
  const listingId = formattedListingId.uuid;
  dispatch(fetchListingTransactionsRequest());
  return sdk.transactions
    .query({
      only: 'sale',
      listingId,
      lastTransitions: [
        'transition/request-zero-payment',
        'transition/decline-zero-payment',
        'transition/confirm-zero-payment',
        'transition/worker-cancel',
        TRANSITION_WORKER_CANCEL_BEFORE_START_1,
        TRANSITION_WORKER_CANCEL_BEFORE_START_24,
      ],
      perPage,
      page,
      include: [
        'customer',
        'customer.profileImage',
        'customer.profile.displayName',
        'customer.profile.publicData',
        'listing',
        'listing.title',
        'listing.publicData',
        'listing.price',
      ],
    })
    .then(response => {
      let finalData = [];
      apiResp = response;
      response.data.data.reduce((acc, curr) => {
        let data = { transaction: curr };
        let customer = response.data.included.find(
          ({ id }) => id.uuid === curr.relationships.customer.data.id.uuid
        );

        // let listing = response.data.included.find(
        //   ({ id }) => id.uuid === curr.relationships.listing.data.id.uuid
        // );
        dispatch(
          addMarketplaceEntities({
            data: { data: customer, included: response.data.included },
            status: 200,
            statusText: 'ok',
          })
        );
        customer.profileImage = response.data.included.find(
          ({ id }) => id.uuid === curr.relationships.customer.data.id.uuid
        ).relationships?.profileImage?.data?.id?.uuid;

        finalData = [
          ...finalData,
          {
            ...data,
            customer,
          },
        ];
      }, {});

      return finalData;
    })
    .then(response => {
      dispatch(
        fetchListingTransactionsSuccess({
          data: response.map(res => ({
            ...res,
            customer: getMarketplaceEntities(getState(), [
              { id: res.customer.id, type: 'user' },
            ])?.[0],
          })),
          formattedListingId,
          listingId,
        })
      );
      return apiResp;
    })
    .catch(error => {});
};

export const fetchListingPendingApprovals = ({
  userIds,
  listingData: { listingIds, listingUsers },
}) => async (dispatch, getState, sdk) => {
  dispatch(fetchListingTransactionsRequest());
  const listingsResp = await sdk.listings.query(
    {
      ids: listingIds,
    },
    { expand: true }
  );

  const userPromises = userIds?.slice(0, 4).map(id =>
    sdk.users
      .show({
        id,
        include: ['profileImage', 'profile.publicData'],
      })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        return response;
      })
  );
  const usersResp = await Promise.all(userPromises);
  const formattedUser = usersResp.map(res => {
    return getMarketplaceEntities(getState(), [{ type: 'user', id: res.data.data.id }])[0];
  });
  const demoArr = listingsResp.data.data?.map((listing, index) => ({
    listing,
    users: formattedUser.filter(user =>
      listingUsers.find(l => l?.listingId === listing?.id?.uuid)?.workers?.includes(user.id.uuid)
    ),
  }));
  // console.log(3666, usersResp, formattedUser, { data: demoArr, meta: listingsResp.data.meta });
  return dispatch(
    fetchListingAwaitingAcceptanceSuccess({ data: demoArr, meta: listingsResp.data.meta })
  );
};
export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const { id } = params;
  const formattedListingId = new UUID(id);
  const queryParams = parse(location.search);
  // console.log(222, params, queryParams, queryParams.search, search);
  //    const url = window.location.href;
  //    const urlObject = new URL(url);
  //    const pathname = urlObject.pathname;

  //    const parts = pathname.split('/');

  //    const id = parts[parts.length - 1];
  // if (search.split('?')?.[1] === 'awaiting') {
  // sdk.listings.query({ ids: id }).then(res => {
  //   const data = res?.data?.data[0];
  //   dispatch(fetchListingSuccess(data));
  // });
  if (queryParams.search === 'awaiting') {
    // dispatch(fetchListingAwaitingAcceptanceRequest());
    dispatch(fetchAssignedWorkerRequest());
    if (!id) {
      return Promise.reject(new Error(`Invalid id`));
    }
    try {
      const data = await dispatch(fetchCurrentUser());
      const {
        user: { currentUser },
      } = getState();
      // const iiii = await axios.post(`${apiBaseUrl()}/api/user/getAssignedDataByBusinessId`, {
      //   businessId: currentUser.id.uuid,
      //   page: 0,
      // });

      // const listingIds = [];
      // const listingUsers = [];
      // const queryUser = iiii.data.data.reduce((total, current) => {
      //   listingIds.push(current.listingId);
      //   listingUsers.push({
      //     listingId: current.listingId,
      //     workers: current?.data?.map(d => d.workerId),
      //   });
      //   return [...new Set([...total, ...current?.data?.map(d => d.workerId)])];
      // }, []);
      // // console.log(1234, listingUsers, iiii, queryUser, listingIds);

      //  dispatch(
      //   fetchListingPendingApprovals({
      //     userIds: queryUser,
      //     listingData: { listingIds, listingUsers },
      //   })
      // );
      await axios
        .post(`${apiBaseUrl()}/api/user/getAwaitingListingData`, {
          listingId: id,
        })
        .then(res => {
          const workerIdArray = res?.data?.map(m => m.workerId);
          return Promise.all(
            workerIdArray.map(m =>
              sdk.users.show(
                {
                  id: m,
                  include: ['profileImage'],
                  'fields.image': [
                    'variants.default',
                    'variants.square-small',
                    'variants.square-small2x',
                  ],
                },
                { expand: true }
              )
            )
          );
        })
        .then(res => {
          const result = res.map(m => {
            dispatch(addMarketplaceEntities(m));
            return m.data;
          });
          // console.log(333, result);

          dispatch(fetchAssignedWorkerSuccess(result));
        });
    } catch (err) {
      //  dispatch(fetchListingAwaitingAcceptanceError(err));
      dispatch(fetchAssignedWorkerError(err));
    }
  }
  // else {

  dispatch(fetchListingRequest());
  return sdk.ownListings
    .show({ id: id })
    .then(res => {
      const data = res?.data?.data;
      dispatch(fetchListingSuccess(data));
    })
    .then(res => {
      return dispatch(fetchListingTransactions(formattedListingId));
    });
  // }
};
